import { useApp } from '../context/AppContext';
import { normalizeLang, translate } from './messages';

export function useI18n() {
  const { state } = useApp();
  const lang = normalizeLang(state.preferences.language);
  return {
    lang,
    dir: lang === 'ar' ? 'rtl' : 'ltr',
    t: (key, vars) => translate(lang, key, vars),
  };
}
